// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"fecf8cf3","513":"9d321f49","703":"510b58bc"}[chunkId] + ".chunk.js";
};